export default __webpack_public_path__ + "static/media/balance-and-invoicing.f06ecd2f.png";